import React from "react";
import { Link } from "react-router-dom";
import { Clock } from "@phosphor-icons/react";

const CATEGORY_COLORS = {
  Sommeil: "#9CAEA9",
  Allaitement: "#D8A7A7",
  Émotions: "#C57B67",
  Récupération: "#D3B683",
  "Récupération Physique": "#D3B683",
  "Les Indispensables": "#88A096",
};

export function categoryColor(cat) {
  return CATEGORY_COLORS[cat] || "#C57B67";
}

export default function ArticleCard({ article, index = 0 }) {
  const color = categoryColor(article.category);
  return (
    <Link
      to={`/article/${article.id}`}
      data-testid={`article-card-${article.id}`}
      className="group block rounded-3xl border border-[#36302B]/5 bg-white p-5 shadow-[0_4px_20px_rgba(54,48,43,0.03)] transition-transform hover:-translate-y-1"
      style={{ animationDelay: `${Math.min(index * 40, 300)}ms` }}
    >
      <div className="mb-3 flex items-center gap-2">
        <span
          className="rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide"
          style={{ backgroundColor: `${color}22`, color }}
        >
          {article.category}
        </span>
      </div>
      <h3 className="font-display text-[19px] font-medium leading-snug text-[#36302B]">
        {article.title}
      </h3>
      <p className="mt-2 text-[14px] leading-relaxed text-[#36302B]/65">{article.excerpt}</p>
      {article.read_time && (
        <div className="mt-3 flex items-center gap-1.5 text-[12.5px] text-[#36302B]/45">
          <Clock size={15} />
          {article.read_time} de lecture
        </div>
      )}
    </Link>
  );
}
